import jQuery from 'jquery';

jQuery(function($) {
  // Регистрация/Вход в ЛК
  let $loginTabs = $('.login__tabs');
  let $loginTab = $loginTabs.find('.login__tab');
  let $forms = $('.form--register, .form--login');

  $loginTab.on('click', function() {
    let $tab = $(this);

    $forms.addClass('d-none');
    $forms.filter('.form--' + $tab.data('form')).removeClass('d-none');

    $loginTab.removeClass('login__tab--active');
    $tab.addClass('login__tab--active');
  });

  // Вход через почту/телефон
  let $signInForm = $('.form--login');
  let $signInTabs = $signInForm.find('.sign-in__tabs');
  let $signInTab = $signInTabs.find('.sign-in__tab');
  let $signInFields = $signInForm.find('.form__field');

  $signInTab.on('click', function() {
    let $tab = $(this);

    function toggleFields(type) {
      let $field = $signInFields.filter('.form__field--' + type);
      $field.prop('disabled', $tab.data('type') !== type);
      $field.closest('.form__row').toggleClass('d-none', $tab.data('type') !== type);
    }

    toggleFields('email');
    toggleFields('phone');

    $signInTab.removeClass('sign-in__tab--active');
    $tab.addClass('sign-in__tab--active');

  });
});
